import * as React from 'react';

import * as styles from './styles.css';

export const BookedOfferLayoutsWrapper: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <div className={styles['wrapper']} data-testid="booked-offer-layouts" id="booked-offer-layouts">
      {children}
    </div>
  );
};
